export type SupportedColor = string;

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

const parseHex = (color: string) => {
  const match = color.trim().match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!match) return null;

  let hex = match[1];
  if (hex.length === 3) {
    hex = hex.split('').map((c) => c + c).join('');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return { r, g, b };
};

const toHex = (value: number) => {
  const hex = clamp(Math.round(value), 0, 255).toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

export const darkenColor = (color: SupportedColor, amount = 0.15): SupportedColor => {
  const parsed = parseHex(color);
  if (!parsed) return color;

  const factor = clamp(1 - amount, 0, 1);
  const r = toHex(parsed.r * factor);
  const g = toHex(parsed.g * factor);
  const b = toHex(parsed.b * factor);

  return `#${r}${g}${b}`;
};

export const colorWithAlpha = (color: SupportedColor, alpha: number): SupportedColor => {
  const parsed = parseHex(color);
  if (!parsed) return color;

  const safeAlpha = clamp(alpha, 0, 1);
  return `rgba(${parsed.r}, ${parsed.g}, ${parsed.b}, ${safeAlpha})`;
};

